import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { useEffect, useRef, useState } from 'react';
import { defaultCenter } from './static';

export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}


function GMapsWithDraggableCenter(props: any) {
  const {
    location = undefined,
    changingCenter,
    zoom = 7,
    center = (location?.lat && location?.lng)
      ? props.location
      : defaultCenter
  } = props;
  const [position, setPosition] = useState({
    lat: location?.lat || 37.9838096,
    lng: location?.lng || 23.7275388
  });

  const debouncedValue = useDebounce<string>(position as any, 500);

  useEffect(() => {
    changingCenter && changingCenter(position);

  }, [debouncedValue]);

  const mapRef = useRef<any>(null);

  function handleLoad(map: google.maps.Map) {
    mapRef.current = map;
  }

  function handleCenterChanged() {
    if (!mapRef.current) return;
    const newPos = mapRef.current.getCenter().toJSON();
    setPosition(newPos);
  }

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  });

  return (<>
    {isLoaded && <GoogleMap
      onLoad={handleLoad}
      onCenterChanged={handleCenterChanged}
      options={{
        draggable: true
      }}
      mapContainerStyle={{
        height: '400px',
        width: '100%'
      }}
      zoom={zoom}
      center={center}
    >
      {
        location
          ? <MarkerF
            position={position}
          />
          : null
      }

    </GoogleMap>
    }
  </>);
}

export default GMapsWithDraggableCenter;